import { render, staticRenderFns } from "./userAuth.vue?vue&type=template&id=06cec465&scoped=true"
import script from "./userAuth.vue?vue&type=script&lang=js"
export * from "./userAuth.vue?vue&type=script&lang=js"
import style0 from "./userAuth.vue?vue&type=style&index=0&id=06cec465&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cec465",
  null
  
)

export default component.exports